const wheelEnums = {
  SECTOR_0: 0,
  SECTOR_1: 1,
  SECTOR_2: 2,
};

Object.freeze(wheelEnums);

export default wheelEnums;
